(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["prison-pdp-editorial-ui"] && !Shopify.designMode) return;
  try {
    (() => {
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const chooseSize = () => {
      const target = document.querySelector('.wt-product__options');
      if (!target) return;
      target.scrollIntoView({ behavior: reduced.matches ? 'instant' : 'smooth', block: 'center' });
      const input = target.querySelector('input[type="radio"]:not(.disabled)') || target.querySelector('select') || target.querySelector('button');
      if (input) input.focus({ preventScroll: true });
    };
    document.addEventListener('click', (event) => {
      const guide = event.target.closest('[data-prison-size-guide]');
      if (guide) {
        const opener = document.querySelector('.wt-product__option__size-guide modal-opener button');
        if (opener) opener.click(); else chooseSize();
        return;
      }
      if (event.target.closest('[data-prison-choose-size]')) { chooseSize(); return; }
      const trigger = event.target.closest('[data-prison-dialog]');
      if (trigger) {
        const dialog = document.getElementById(trigger.dataset.prisonDialog);
        if (dialog && typeof dialog.showModal === 'function') {
          dialog.showModal();
          dialog.addEventListener('close', () => trigger.focus({ preventScroll: true }), { once: true });
        }
        return;
      }
      if (event.target.matches('.prison-pdp-dialog[open]')) {
        const bounds = event.target.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) event.target.close();
      }
    });
    if (!('IntersectionObserver' in window) || reduced.matches) return;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.dataset.entered = '';
        observer.unobserve(entry.target);
      });
    }, { threshold: .08 });
    const observe = (root) => root.querySelectorAll('[data-prison-reveal]:not([data-entered])').forEach((item) => observer.observe(item));
    observe(document);
    document.addEventListener('shopify:section:load', (event) => observe(event.target));
    document.addEventListener('shopify:section:unload', (event) => event.target.querySelectorAll('[data-prison-reveal]').forEach((item) => observer.unobserve(item)));
  })();
  } catch(e) { console.error(e); }
})();

})();
